/*
 * @Author: Veto [关于蜜柚部分 路由]
 * @Date: 2021-06-16 16:08:20 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2022-09-21 11:55:35
 */

import Female from '../views/warning/female';
import FAQ from '../views/warning/faq';
import Male from '../views/warning/male';
import FAQ_LIAOBAN from '../views/warning/faq_liaoban';
import Sample from '../views/warning/sample';


const router = {
    '/warning-female': Female,
    // '/warning-male': Male,
    '/warning-male': Female,
    '/warning-faq': FAQ,
    '/warning-faq-liaoban': FAQ_LIAOBAN,

    '/warning-sample': Sample,
};


export default router;